export default __webpack_public_path__ + "static/media/papaiz.72996dbf.png";